<script>
  import { link, push } from "svelte-spa-router";
  import active from "svelte-spa-router/active";
  import { User } from "sveltefire";

  import Profile from "../dumb/Profile.svelte";

  const signOut = (auth) => {
    auth.signOut();
    push("/");
  };
</script>

<nav class="navbar">
  <a
    class="navbar__tab"
    href="/organize"
    use:link
    use:active={{ path: '/organize', className: 'active', inactiveClassName: 'inactive' }}>Organize</a>
  <a
    class="navbar__tab"
    href="/transcribe"
    use:link
    use:active={{ path: '/transcribe', className: 'active', inactiveClassName: 'inactive' }}>Transcribe</a>
  <User let:user let:auth>
    {#if user.photoURL}
      <Profile url={user.photoURL} text={user.email} on:click={() => signOut(auth)} />
    {:else}
      <Profile text={user.email} on:click={() => signOut(auth)} />
    {/if}
  </User>
</nav>

<style>
  .navbar {
    grid-area: header;
    background-color: var(--green);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: stretch;
    align-items: flex-start;
  }

  .navbar__tab {
    flex: 0 1 100px;
    align-self: flex-end;
    text-align: center;
    border: 1px solid var(--dark-brown);
    border-radius: 2px 2px 0px 0px;
    font-family: "Work Sans", sans-serif;
    font-weight: 600;
    margin-right: 2px;
    text-decoration: none;
  }

  :global(.navbar__tab.active) {
    background-color: var(--dark-brown);
    color: var(--white);
    padding-top: 1px;
  }

  :global(.navbar__tab.inactive) {
    background-color: var(--white);
    color: var(--dark-brown);
    padding-top: 0px;
  }

  :global(.navbar__tab.inactive:hover) {
    background-color: var(--silver);
    text-decoration: underline;
  }
</style>
